<template>
  <transition name="slideup">
    <div v-if="playlist && playlist.length">
      <!-- <PlayerMini
        :playing="reading && !paused"
        :title="markerSpeech.title"
        :poster="markerSpeech.image"
        @play="play"
        @pause="pause"
        @next="next"
        @prev="prev" /> -->
      <!-- <PlayerHeader
        :playing="reading && !paused"
        @play="play"
        @stop="stopCurrentPlaylist"
        @next="next"
        @prev="prev" /> -->
      <PlayerHeader
        :playing="reading && !paused"
        @play="play"
        @pause="pause"
        @next="next"
        @prev="prev"
        @stop="stopCurrentPlaylist"
      />
    </div>
  </transition>
</template>

<script>
// import PlayerMini from '@/components/ui/Player/PlayerMini'
import PlayerHeader from '@/components/ui/Player/PlayerHeader'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SpeechPlayer',
  components: {
    // PlayerMini,
    PlayerHeader
  },
  computed: {
    ...mapGetters({
      markerSpeech: 'speech/markerSpeech',
      currentIndex: 'speech/currentIndex',
      playlist: 'speech/playlist',
      reading: 'speech/reading',
      paused: 'speech/paused'
    })
  },
  methods: {
    ...mapActions({
      resume: 'speech/resume',
      pause: 'speech/pause',
      // stop: 'speech/stop',
      playTrackByIndex: 'speech/playTrackByIndex',
      stopCurrentPlaylist: 'speech/stopCurrentPlaylist'
    }),
    play () {
      if (this.paused) this.resume()
      else this.playTrackByIndex(0)
    },
    next () {
      if (this.currentIndex < this.playlist.length) {
        this.playTrackByIndex(this.currentIndex + 1)
      }
    },
    prev () {
      if (this.currentIndex - 1 > -1) {
        this.playTrackByIndex(this.currentIndex - 1)
      }
    }
  }
}
</script>
